import type { ReactNode } from 'react';

export interface TabItem {
  id: string;
  label: string;
  count?: number;
  icon?: ReactNode;
}

export interface TabsProps {
  items: TabItem[];
  value: string;
  onChange: (id: string) => void;
  size?: 'sm' | 'md';
}

/**
 * לשוניות בסגנון "בורר מקטעים" של עיצוב v2 (גלולה אפורה, הפעילה מורמת
 * בלבן) — כמו "לידים / אנשי קשר / חסומים". גלילה אופקית כשאין מקום.
 */
export function Tabs({ items, value, onChange, size = 'md' }: TabsProps) {
  return (
    <div style={{ maxWidth: '100%', overflowX: 'auto', overflowY: 'hidden', flex: 'none' }}>
      <div role="tablist" className="seg">
        {items.map((item) => {
          const active = item.id === value;
          return (
            <button
              key={item.id}
              type="button"
              role="tab"
              aria-selected={active}
              onClick={() => onChange(item.id)}
              style={size === 'sm' ? { height: 28, padding: '0 11px', fontSize: 'var(--t-xs)' } : undefined}
            >
              {item.icon}
              {item.label}
              {typeof item.count === 'number' && <span className="seg-count">{item.count}</span>}
            </button>
          );
        })}
      </div>
    </div>
  );
}
